import { createAction } from 'redux-actions';
export var setFirstTimeFlags = createAction('@@firstTimeFlags/SET_FLAGS', function (payload) { return payload; });
export var dropFirstTimeFlag = createAction('@@firstTimeFlags/DROP_FLAG', function (payload) { return payload; });
export var dropFirstTimeFlagSimple = function (flag, redirectTo) { return dropFirstTimeFlag({ flag: flag, redirectTo: redirectTo }); };
//# sourceMappingURL=actions.js.map